import { atom } from 'jotai';

/**
 * Whether the Data Desk right panel is open
 */
export const dataDeskOpenAtom = atom<boolean>(false);
